export type WorkspaceEditLockOwner = 'outline-inline' | 'node-editor-overlay';

export interface WorkspaceEditLock {
	nodeId: string;
	owner: WorkspaceEditLockOwner;
	acquiredAt: string;
}

export type WorkspaceEditLockMap = Record<string, WorkspaceEditLock>;

export function acquireWorkspaceEditLock(
	locks: WorkspaceEditLockMap,
	requestedLock: WorkspaceEditLock,
): { locks: WorkspaceEditLockMap; granted: boolean; blockingLock?: WorkspaceEditLock } {
	const blockingLock = locks[requestedLock.nodeId];

	if (blockingLock && blockingLock.owner !== requestedLock.owner) {
		return {
			locks,
			granted: false,
			blockingLock,
		};
	}

	return {
		locks: {
			...locks,
			[requestedLock.nodeId]: requestedLock,
		},
		granted: true,
	};
}

export function releaseWorkspaceEditLock(
	locks: WorkspaceEditLockMap,
	nodeId: string,
	owner?: WorkspaceEditLockOwner,
): WorkspaceEditLockMap {
	const existingLock = locks[nodeId];
	if (!existingLock) {
		return locks;
	}

	if (owner && existingLock.owner !== owner) {
		return locks;
	}

	const nextLocks = { ...locks };
	delete nextLocks[nodeId];
	return nextLocks;
}

export function getWorkspaceEditLock(locks: WorkspaceEditLockMap, nodeId: string): WorkspaceEditLock | null {
	return locks[nodeId] ?? null;
}